import _ from 'lodash';

export function debounce(wait: number) {
	return function (
		target: any,
		propertyKey: string,
		descriptor: PropertyDescriptor,
	) {
		descriptor.value = _.debounce(descriptor.value, wait);
		return descriptor;
	};
}

export function throttle(wait: number) {
	return function (
		target: any,
		propertyKey: string,
		descriptor: PropertyDescriptor,
	) {
		descriptor.value = _.throttle(descriptor.value, wait);
		return descriptor;
	};
}
